<template>
  <div class="out-bg">
    <!--<div class="cloud" :style="{background: cloud}"></div>-->
    <div class="bg-box">
      <div class="bg" :style="{background: bg}">
        <div class="bg-thumb g-fl">
          <div class="txt">
            <nslider :pages="slide" :sliderinit="sliderinit"></nslider>
          </div>
        </div>
        <div class="bg-icon">
          <div class="f-clearfix">
            <div class="out-box">
              <div class="ipt-box login-box g-fr">
                <div>
                  <div class="logo" :style="{background: logoStyle}"></div>
                  <ul v-if="isLogin">
                    <li class="g-mb-16">
                      <input type="text" v-model="email" class="ipt" placeholder="邮箱" @keydown="loginKeyDown"/>
                    </li>
                    <li class="g-mb-16">
                      <input type="password" v-model="pwd" class="ipt" placeholder="密码" @keydown="loginKeyDown"/>
                    </li>
                    <li class="login-fn">
                      <Checkbox v-model="remember">在电脑上保持登陆</Checkbox>
                      <a href="javascript:;" class="forget" @click="toForget">忘记密码？</a>
                    </li>
                  </ul>
                  <ul v-else>
                    <li class="g-mb-16">
                      <input type="text" v-model="email" class="ipt" placeholder="邮箱">
                    </li>
                    <li class="g-mb-16">
                      <div class="ipt ipt-group">
                        <input type="text" v-model="veriCode" class="" placeholder="验证码">
                        <button type="button" @click="getVeriCode">{{veriBtnTxt}}</button>
                      </div>
                      <!--<i-input v-model="veriCode" size="large" class="ipt ipt-group" placeholder="">-->
                      <!--<Button slot="append"></Button>-->
                      <!--</i-input>-->
                    </li>
                    <li class="g-mb-16">
                      <input type="password" v-model="pwd" class="ipt" placeholder="新密码">
                    </li>
                    <li class="g-mb-16">
                      <input type="password" v-model="repeatPwd" class="ipt" placeholder="确认新密码">
                    </li>
                    <li class="login-fn">
                      <a href="javascript:;" class="forget" @click="toForget">返回登陆</a>
                    </li>
                  </ul>
                  <button class="login-btn" v-if="isLogin" @click="login">账号登录</button>
                  <button class="login-btn" v-else @click="resetPwd">重设密码</button>
                  <!--<div v-if="isLogin" class="other-login">-->
                  <!--<h6>第三方登陆</h6>-->
                  <!--<div>-->
                  <!--<a href="javascript:;"></a>-->
                  <!--</div>-->
                  <!--</div>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="next-brief">
      <div class="introduce">
        <p class="title">Excalib<span style="border-bottom: solid 2px #4496EF;">ur项</span>目简介</p>
        <div class="int-box">
          <div class="int-l">
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;由商业智能时代的领军者-盖雅科技自主研发，Excalibur作为面向创作型企业与创意精英的一<br>
              体化赋能平台，架构协同创作流程，优化办公成本，自动化搭建知识体系，采用人工智能算法<br>
              分析商业经营，打造智慧企业大脑，帮助创作型企业完善从创作到沉淀不断积累公司的护城河<br>
              的路径，从而帮助企业实现智能化经营。</p>
          </div>
          <div class="int-r">
            <img src="../../assets/images/int-r.png">
          </div>
        </div>
      </div>
    </div>
    <div class="next-fun">
      <div class="function">
        <p class="title">Excalib<span style="border-bottom: solid 2px #4496EF;">ur功</span>能介绍</p>
        <div class="fun-box">
          <div class="out-fun">
            <div class="in-fun">
              <p class="title">标准化作业模块</p>
              <div class="icon">
                <img src="../../assets/images/fun02.svg">
              </div>
              <div class="word">
                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;强大的SOP工具包覆盖各个创作流程，涵盖策<br>
                  划、创意、数据、媒介、拍摄等，内嵌模板将引导创<br>
                  作者快速创建和实施工作，以行业的知识积累帮助员<br>
                  工快速标准的完成内容创作;</p>
                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  整合项目任务管理、知识库、审批流程、人事财<br>
                  务报表、数据报表、客户和供应商库等模块，提升<br>
                  跨职能协作效率，实现项目与公司资源的有效管理。
                </p>
              </div>
            </div>
          </div>
          <div class="out-fun">
            <div class="in-fun">
              <p class="title">办公流程管控模块</p>
              <div class="icon">
                <img src="../../assets/images/fun01.svg">
              </div>
              <div class="word">
                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;建立以项目和任务为中心的高效协作机制，链接各<br>
                  个相关系统，实时协作和推进任务；通过Dashboard快<br>
                  速全面地了解个人和各个成员的成效，掌握工作的推进<br>
                  情况，形成从管理任务目标、了解执行反馈和获取工作<br>
                  总结以及评定工作绩效的管理闭环，服务于业务，提升<br>
                  企业经营效率。
                </p>
              </div>
            </div>
          </div>
        </div>
          <div class="fun-box">
          <div class="out-fun">
            <div class="in-fun">
              <p class="title">行业与企业知识库</p>
              <div class="icon">
                <img src="../../assets/images/fun04.svg">
              </div>
              <div class="word">
                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;通过在线云舟吸收团队所有的知识内容，积累创<br>
                  作产出，记录创作过程，自动形成大数据包，并通过<br>
                  人工智能算法挖掘数据关系，经工具包自动形成经验<br>
                  库和知识库，以实现知识沉淀和共享；同时，允许用<br>
                  户传播分享生成的经验库和知识库，实现知识体系变<br>
                  现和商业经营，共同打造行业知识库和企业智本中<br>
                  心。
                </p>
              </div>
            </div>
          </div>
          <div class="out-fun">
            <div class="in-fun">
              <p class="title">商业智能分析模块</p>
              <div class="icon">
                <img src="../../assets/images/fun03.svg">
              </div>
              <div class="word">
                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;大数据拥抱云计算，人工智能拥抱大数据。用知识<br>
                  数据训练人工智能，分析企业本身商业情况，对经营业<br>
                  绩、运营管理等作出智能分析，打造智慧企业大脑，实<br>
                  现企业商业经营一体化智能赋能。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="next-stu" :style={background:button}>
      <div class="stu">
        <p class="title">酷拓文化交流（<span style="border-bottom: solid 2px #4496EF;">上海</span>）有限公司简介</p>
        <div class="stu-but">
          <div class="stu-l">
            <img src="../../assets/images/but-l.png">
          </div>
          <div class="stu-r">
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;酷拓文化交流（上海）有限公司（以下简称酷拓COOLTOUR）成立于2016年，以“科技+数据+IP”为核心的DNA，致力于推进中国IP产业和内容产业的发展。 酷拓文化交流（上海）有限公司与关于中国玩具和婴童用品协会联合推出【IP365X】作为面向授权行业的服务型平台，将为行业打通上下游信息、实现行业社交、科学理性授权等提供服务于决策依据，并提供后续的营销支持。</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们提供企业、品牌、产品与企业家的商业影响力塑造建议与解决方案，提供传播层面内容策划、发布、传播、分发与效果监测服务，提供IP企业内部基于传播与内容层面的问题诊断、咨询定位、培训、代理等，拥有专属团队，可以快速决策、执行，深度陪伴。</p>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="top" @click="backTop" v-show="showTop">
        <img src="../../assets/images/return.svg" alt="">
      </div>
      <div class="out-fo">
        <div class="fo-box">
          <div class="fo-l">
            <p class="top-title">联系我们</p>
            <p><img src="../../assets/images/call.png">021-5280-9679</p>
            <p><img src="../../assets/images/email.png">business@normcore.com</p>
            <p><img src="../../assets/images/location.png">上海市长宁区天山路1900号9层</p>
            <p>
              <span>Copyright @2019 EXCALIBUR.WORK</span>
              <a class="ip_a" href="https://beian.miit.gov.cn/" target="_blank">沪ICP备15006750号-4</a>
            </p>
          </div>
          <!--<div class="fo-m">-->
            <!--<p class="top-title">服务条款</p>-->
            <!--<p>法务条款</p>-->
            <!--<p>使用条款</p>-->
            <!--<p>版权声明</p>-->
          <!--</div>-->
          <!--<div class="fo-r">-->
            <!--<p class="top-title">关于我们</p>-->
            <!--<p>公司介绍</p>-->
            <!--<p>加入我们</p>-->
          <!--</div>-->
          <div class="code">
            <p>扫码添加客服微信</p>
            <img src="../../assets/images/code.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <toast :is-toast="isToast" :msg="toastMsg" :status="toastState"></toast>
  </div>
</template>

<script>
  import {Login} from '../../API/api'
  import iconBg from '../../assets/images/bg_icon.png'
  // import bg from '../../assets/images/bg.png'
  import bg from '../../assets/images/banner.jpg'
  import button from '../../assets/images/bot-bg.png'
  import logoImg from '../../assets/images/logo@2x.png'
  import Toast from '../../components/popup/Toast'
  import pic from '../../assets/images/pic.svg'
  import cloud from '../../assets/images/path-24.svg'
  import nslider from 'vue-concise-slider'
  import Cookies from 'js-cookie'


  export default {
    name: 'login',
    components: {Toast, nslider},
    data () {
      return {
        slide: [
          {
            html: '<div style="width: 100%;"><h1 style="font-size: 32px; color: #fff;">Make Things Happen</h1></div>',
            style: {
              'text-align': 'center'
            }
          },
          {
            html: '<div style="width: 100%;"><h1 style="font-size: 32px; color: #fff;">Get Things Done</h1></div>',
            style: {
              'text-align': 'center'
            }
          },
          {
            html: '<div style="width: 100%;"><h1 style="font-size: 32px; color: #fff;">Keep People Updated</h1></div>',
            style: {
              'text-align': 'center'
            }
          }
        ],
        sliderinit: {
          currentPage: 0,
          thresholdDistance: 500,
          thresholdTime: 100,
          autoplay: 2000,
          loop: true,
          direction: 'vertical',
          infinite: 1,
          slidesToScroll: 1,
          timingFunction: 'ease',
          duration: 300
        },
        email: '',
        copyLoop: 0,
        remember: false,
        isLogin: true,
        veriCode: '',
        pwd: '',
        repeatPwd: '',
        isToast: false,
        toastMsg: null,
        toastState: null,
        waitTime: 60,
        canSend: true,
        scrollTop: 0,
        veriBtnTxt: '获取验证码',
        bg: `url("${bg}") no-repeat center scroll transparent`,
        button: `url("${button}") repeat-x bottom scroll transparent`,
        cloud: `url("${cloud}") repeat center scroll transparent`,
        pic: `url("${pic}") repeat center scroll transparent`,
        iconBgStyle: `url("${iconBg}") repeat center scroll transparent`,
        logoStyle: `url("${logoImg}") no-repeat 0 0 / contain scroll transparent`
      }
    },
    created () {
      // this.checkLogin()
      this.$Notice.destroy()
      Cookies.remove('token')
    },
    computed: {
      showTop: function () {
        let value = this.scrollTop > 200
        return value
      }
    },
    mounted () {
      this.$Notice.destroy()
      window.addEventListener('scroll', this.ScrollToTop)
    },
    methods: {
      loginKeyDown (e) {
        if (e.keyCode === 13) {
          this.login()
        }
      },
      checkLogin () {
        // if (this.$cookie.)
        if (this.$cookie.get('token')) {
          this.$router.replace('/v2/home')
        }
      },
      backTop () {
        let that = this
        let timer = setInterval(() => {
          let ispeed = Math.floor(-that.scrollTop / 5)
          document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
          if (that.scrollTop === 0) {
            clearInterval(timer)
          }
        }, 16)
      },
      ScrollToTop () {
        this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      },
      getVeriCode () {
        if (this.canSend) {
          if (!this.email) {
            this.isToast = true
            this.toastMsg = '请输入邮箱'
            setTimeout(() => {
              this.isToast = false
              this.toastMsg = null
            }, 1500)
            return
          }
          this.canSend = false
          let reSendTime = setInterval(() => {
            this.veriBtnTxt = this.waitTime + '后可重发'
            this.waitTime--
            if (this.waitTime <= 0) {
              this.canSend = true
              this.waitTime = 60
              clearInterval(reSendTime)
              this.veriBtnTxt = '获取验证码'
            }
          }, 1000)
          this.$http.post(Login.veriCode, this.qs.stringify({email: this.email})).then(res => {
            let _data = res.data
            this.isToast = true
            if (_data.retCode === 0) {
              this.toastMsg = '发送成功'
              this.toastState = 'success'
            } else {
              this.toastMsg = _data.retMsg
              this.toastState = null
              this.veriBtnTxt = '获取验证码'
              this.waitTime = 60
              this.canSend = true
              clearInterval(reSendTime)
            }
            setTimeout(() => {
              this.isToast = false
              this.toastMsg = null
              this.toastState = null
            }, 1500)
          })
        }
      },
      resetPwd () {
        if (this.pwd !== this.repeatPwd) {
          this.isToast = true
          this.toastMsg = '两次密码不一致'
          setTimeout(() => {
            this.isToast = false
            this.toastMsg = null
          }, 1500)
          return
        }
        this.$http.post(Login.forgetPwd, this.qs.stringify({
          password: this.pwd,
          verification: this.veriCode,
          repeatPwd: this.repeatPwd,
          email: this.email
        })).then(res => {
          let _data = res.data
          this.isToast = true
          if (_data.retCode === 0) {
            this.toastMsg = '设置成功，返回登陆'
            this.toastState = 'success'
          } else {
            this.toastMsg = _data.retMsg
            this.toastState = null
          }
          setTimeout(() => {
            this.isToast = false
            this.toastMsg = null
            this.toastState = null
            this.isLogin = true
            this.pwd = ''
          }, 1500)
        })
      },
      toForget () {
        this.isLogin = !this.isLogin
      },
      login () {
        let data = {
          email: this.email,
          password: this.pwd,
          remember: this.remember ? 1 : 0
        }
        this.$http.post(Login.login, this.qs.stringify(data)).then((res) => {
          let _data = res.data
          if (_data.retCode === 0) {
          
            if (this.remember) {
              this.$cookie.set('token', _data.retData.token, 9999)
            } else {
              this.$cookie.set('token', _data.retData.token)
            }
            let userInfo = {
              userName: _data.retData.userName,
              id: _data.retData.id,
              headPic: _data.retData.headPic,
              mobile: _data.retData.mobile,
              teamName : _data.retData.teamName,
              
            }
            this.$cookie.set('userInfo', JSON.stringify(userInfo));
            localStorage.setItem('userInfo', JSON.stringify(userInfo))
            sessionStorage.setItem('subMenu', 'home')
            this.$store.dispatch('setOpenedSub', 'tasks')
            sessionStorage.setItem('openedSub', 'tasks')
            // this.$router.push('/projects/list')
            this.$router.push('/v2/home')
          } else {
            this.isToast = true
            this.toastMsg = _data.retMsg
          }
          setTimeout(() => {
            this.isToast = false
            this.toastMsg = null
          }, 1500)
        })
      }
    },
    destroyed () {
      window.removeEventListener('scroll', this.scrollToTop)
    }
  }
</script>

<style scoped lang="less">
  .out-bg {
    height: 100vh;
  }

  .bg-box{
    background-image: linear-gradient(125deg, #C5B0FF 0%, #5592F8 100%);
  }

  .bg {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    height: 680px;
    /*background-image: linear-gradient(159deg, #59c1fc, #2d8ef8);*/
    /*.cloud {*/
    /*width: 597px;*/
    /*height: 132.9px;*/
    /*position: absolute;*/
    /*bottom: 0;*/
    /*left: 0;*/
    /*}*/
  }

  .bg-icon {
    width: 78%;
    height: 100%;
    position: relative;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .bg-thumb {
    width: 60%;
    position: absolute;
    bottom: 20px;

    .img {
      width: 599px;
      height: 398px;
    }

    .txt {
      text-align: right;
      height: 87px;
      margin-top: -20px;

      h1 {
        font-size: 32px !important;
        color: #fff;
      }

      p {
        font-size: 26px;
        color: #fff;
      }
    }
  }

  .out-box {
    width: 380px;
    height: 433px;
    border: 1px solid #303030;
    background: #ED869C;

    .ipt-box {
      width: 359px;
      height: 412px;
      border: 1px solid #303030;
      background-color: #ffffff;
      box-shadow: 0 2px 4px 0 rgba(134, 142, 150, 0.6);
      /*padding: 0 48px;*/
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 10.5px;

      ul {
        margin-bottom: 48px;
      }

      .ipt {
        height: 42px;
        width: 278px;
        border-radius: 4px;
        border: 1px solid #303030;
        font-size: 14px;
        padding: 0 16px;

        &:focus {
          border-color: #57a3f3;
          outline: 0;
          box-shadow: 0 0 0 2px rgba(45, 140, 240, .2);
        }
      }

      input::-webkit-input-placeholder {
        color: #CED4DA;
        font-size: 14px;
      }

      .ipt-group {
        padding: 0;
        overflow: hidden;
        display: flex;

        button {
          height: 100%;
          border: 0 none;
          background-color: #2d8ef8;
          color: #fff;
          padding: 0 10px;
          transition: background-color .5s;

          &:hover {
            background-color: lighten(#2d8ef8, 10%);
          }

          &:active {
            background-color: darken(#2d8ef8, 10%);
          }
        }

        input {
          flex: 1;
          border: 0 none;
          height: 100%;
          padding: 0 16px;
        }
      }
    }
  }

  .next-brief {
    background-color: #fff;

    .introduce {
      margin: 100px auto;
      width: 90%;

      .title {
        font-size: 30px;
        color: #000000;
        text-align: center;
      }

      .int-box {
        display: flex;
        justify-content: space-around;

        .int-l {
          font-size: 16px;
          color: #666666;
          line-height: 26px;
          padding: 100px 5px;
          margin-right: 50px;
          width:680px;

          p {
            margin-bottom: 10px;
          }
        }

        .int-r {
          width: 400px;
        }
      }
    }
  }

  .next-fun {
    background-image: linear-gradient(0deg, rgba(254, 249, 240, 0.30) 0%, #FCF0DC 100%);

    .function {
      margin: 100px auto;

      .title {
        font-size: 30px;
        color: #000000;
        text-align: center;
        padding-top: 60px;
      }

      .fun-box {
        width: 90%;
        margin: 40px auto 0;
        display: flex;
        justify-content: space-around;

        .out-fun {
          width: 590px;
          height: 280px;
          border: solid 1px #303030;
          border-radius: 4px;
          padding: 15px;
          background-color: #fff;
          margin-bottom: 20px;

          .in-fun {
            width: 560px;
            height: 250px;
            border: 1px dashed #303030;

            .title {
              font-size: 20px;
              color: #303030;
              padding-top: 10px;
            }

            .icon {
              width: 205px;
              padding: 20px;
              float: left;

              img {
                display: block;
              }
            }

            .word {
              font-size: 14px;
              color: #666666;
              line-height: 22px;
              padding: 30px 0;

              p {
                margin-bottom: 10px;
              }
            }
          }
        }
      }
    }
  }

  .next-stu {
    background: no-repeat;

    .stu {
      .title {
        font-size: 30px;
        color: #000000;
        text-align: center;
      }

      .stu-but {
        height: 420px;
        width: 90%;
        margin: 0 auto;
        display: flex;
        justify-content: space-around;
      }

      .stu-l {
        width: 400px;
      }

      .stu-r {
        margin: 20px 0;
        font-size: 16px;
        color: #666666;
        width: 700px;

        p {
          margin: 20px 0;
        }
      }
    }
  }

  .footer {
    background-color: #2E59A7;

    .top {
      width: 88px;
      position: fixed;
      right: 40px;
      bottom: 270px;
      cursor: pointer;
    }

    .out-fo {
      width: 80%;
      margin: 0 auto;

      .fo-box {
        padding-top: 35px;
        display: flex;
        justify-content: space-around;
        font-size: 14px;
        color: #CDCDCD;

        .top-title {
          font-size: 16px;
          color: #FFFFFF;
          margin-bottom: 23px;
        }

        p {
          margin-bottom: 12px;

          img {
            padding: 0 8px 0 0;
          }
        }

        .code {
          p {
            font-size: 14px;
            color: #FFFFFF;
            text-align: center;
          }

          img {
            margin-top: -4px;
            width: 160px;
            padding-bottom: 20px;
          }
        }
      }
    }
  }


  .logo {
    width: 189px;
    height: 38px;
    margin-bottom: 48px;
  }

  .login-btn {
    width: 275px;
    height: 40px;
    /*border-radius: 4px;*/
    border: solid 1px #303030;
    background-color: #2d8ef8;
    color: #fff;
    font-size: 16px;
    outline: none;
    cursor: pointer;
    box-shadow: 3px -3px 0px #ED869C;

    &:hover {
      background-color: lighten(#2d8ef8, 10%);
    }
  }

  .login-fn {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .other-login {
    text-align: center;

    h6 {
      position: relative;
      font-size: 12px;
      color: #ced4da;
    }
  }
  .ip_a {
    margin-left: 20px;
    color: #CDCDCD;
  }
  .ip_a:hover {
    color: #F89A7A
  }

</style>
